<app-navbar title="Ustawienia"></app-navbar>

<div class="form-floating">
	<select
		class="form-select"
		id="sheepType"
		name="sheepType"
		[(ngModel)]="sheepType"
		(ngModelChange)="sheepTypeChanged()"
	>
		<option value="">(brak)</option>
		<option value="bunny">Bunny</option>
		<option value="blue">Blue</option>
		<option value="esheep">Sheep</option>
		<option value="goku">Goku</option>
		<option value="neko">Neko</option>
	</select>
	<label for="sheepType">Rodzaj zwierzątka</label>
</div>
